import { ApiError } from '@/services/api/client';
import { useRevokeOtherSessions, useSessions } from '@/services/queries';
import { Button } from '@/shared/ui/button';

/**
 * The design's red "revoke sessions" card.
 *
 * Scoped to your own account: it ends every session but this one, which is the
 * thing to do after signing in on a shared machine or losing a laptop. Ending
 * other staff members' sessions is an administrator's job in the admin console.
 */
export function SessionsDangerZone() {
  const sessions = useSessions();
  const revoke = useRevokeOtherSessions();

  const others = (sessions.data ?? []).filter((session) => !session.current).length;
  const error = revoke.error instanceof ApiError ? revoke.error.message : null;

  return (
    <section className="flex flex-wrap items-center gap-5 rounded-2xl border border-destructive/40 bg-card px-7 py-6">
      <div className="min-w-0 flex-1">
        <h2 className="text-[15px] font-bold text-destructive">Revoke your other sessions</h2>
        <p className="mt-1 text-[12.5px] leading-normal text-muted-foreground">
          Signs your account out of the operations portal everywhere except this browser.
          {sessions.data &&
            ` ${others === 0 ? 'No other sessions are open.' : `${String(others)} other ${others === 1 ? 'session is' : 'sessions are'} open.`}`}
        </p>
        {error && (
          <p role="alert" className="mt-2 text-sm text-destructive">
            {error}
          </p>
        )}
      </div>
      <Button
        variant="outline"
        className="border-destructive text-destructive hover:bg-destructive hover:text-white"
        disabled={revoke.isPending || (sessions.isSuccess && others === 0)}
        onClick={() => {
          revoke.mutate();
        }}
      >
        {revoke.isPending ? 'Revoking…' : 'Revoke sessions'}
      </Button>
    </section>
  );
}
